




























import Enumerable from "linq";
import { User } from "../../../domain/user";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { HospitalizationHistoryInformation } from "../../../domain/his";
import { DialogMixin } from "../../system/mixins";
import HospitalizationHistorySelector from "../selectors/HospitalizationHistorySelector.vue";
import { Department } from "../../../domain/department";
import { HospitalizationHistorySelectorResult } from "../../../domain/workflow/editor/selectors";

@Component({
  components: {
    HospitalizationHistorySelector,
  },
})
export default class HospitalizationHistorySelectorDialog extends Mixins(DialogMixin) {
  @Prop()
  hospitalizationHistories: HospitalizationHistoryInformation[];

  @Prop()
  allValidUsers: User[];

  @Prop()
  allDepartments: Department[];

  $refs!: {
    selector: HospitalizationHistorySelector,
  };

  data(): any {
    return {
      selectedHospitalizationHisotry: null,
      result: null,
    };
  }
  selectedHospitalizationHisotry: HospitalizationHistoryInformation;
  result: HospitalizationHistorySelectorResult;

  get hasSelected(): boolean {
    return !!this.selectedHospitalizationHisotry;
  }

  onHistorySelectionChanged(value: HospitalizationHistoryInformation): void {
    this.selectedHospitalizationHisotry = value;
  }

  async show(): Promise<HospitalizationHistorySelectorResult> {
    if (!this.hospitalizationHistories || this.hospitalizationHistories.length === 0) {
      return null;
    }

    return this.showModal(async () => {
      this.selectedHospitalizationHisotry = null;
      this.result = null;
      if (this.$refs.selector) {
        this.$refs.selector.clearSelected();
      }
      await this.waitHidden(true);
      return this.result;
    });
  }

  cancel(): void {
    this.selectedHospitalizationHisotry = null;
    this.close();
  }

  select(overwriteUser: boolean): void {
    const selected = this.selectedHospitalizationHisotry.clone();
    selected.doctors = this.getSelectedValidUsers();
    selected.department = this.getSelectedValidDepartment();
    this.result = {
      hospitalizationHistory: selected,
      overwriteUser: overwriteUser,
    };
    this.close();
  }

  private getSelectedValidUsers(): User[] {
    return Enumerable.from(this.selectedHospitalizationHisotry.doctors).select(d => {
      const user = Enumerable.from(this.allValidUsers).firstOrDefault(u => u.id === d.id);
      if (!user) {
        this.$warn("入院歴選択", "既に存在しない医師が選択されました。存在する医師と診療科のみ反映します。");
        return null;
      }
      return user;
    }).where(s => !!s).toArray();
  }

  private getSelectedValidDepartment(): Department {
    return !this.selectedHospitalizationHisotry.department
      ? null
      : Enumerable.from(this.allDepartments).firstOrDefault(d => d.id === this.selectedHospitalizationHisotry.department.id);
  }

  private close(): void {
    this.isVisible = false;
  }
}
